import React from 'react';
import Container from '../shared/Container';
import { Button } from 'flowbite-react';
import { Link } from 'react-router-dom';

interface Props {
	companyName?: string;
}
const AssessmentCompleted = ({ companyName }: Props) => {
	return (
		<Container className="flex items-center">
			<div className="flex max-w-[580px] mx-auto shadow-[0px_2px_4px_0px_rgba(0,0,0,0.12)] bg-[#FFF] rounded-[8px] justify-center">
				<div className="">
					<div className="max-w-[60px] max-h-[60px] mx-auto mt-[64px]">
						<img src="/assets/assessmentcompleted/circle.svg" className="w-full h-full" />
					</div>
					<div className="flex flex-col justify-center items-center gap-[16px] py-[32px] px-[42px]">
						<p className="text-center font-inter text-[24px] font-[500] leading-[30px] text-[#7777E7]">
							Assessment Complete!
						</p>
						<p className="text-center font-inter text-[14px] font-medium leading-[20px] inline-block text-[#555770] px-[43px] pb-[60px]">
							We appreciate the time and effort you put into showcasing your skills. Your results will be reviewed, and
							we’ll be in touch with the next steps soon.
						</p>
						{companyName?.toLowerCase() === 'masai' ? (
							<Link to="/auth/register">
								<Button
									color="purplePlaced"
									data-testid="auth-signup"
									type="submit"
									className={' mt-[-40px] mb-[20px]'}
								>
									Sign up to get access for more jobs
								</Button>
							</Link>
						) : null}
					</div>
				</div>
			</div>
		</Container>
	);
};

export default AssessmentCompleted;
